import {
  Alert,
  Progress,
  Text,
  Group,
  Anchor,
  Box,
  Paper,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

export default function AttendeeLimitBanner({
  ticketsCount,
  attendeeLimit,
  isAttendeeLimitReached,
  isHardBlocked,
}) {
  if (!attendeeLimit) return null;

  const progressValue = Math.min((ticketsCount / attendeeLimit) * 100, 100);

  return (
    <Box mb="xs" mt="xs">
      {isAttendeeLimitReached && (
        <Alert
          color={isHardBlocked ? "red" : "yellow"}
          mb="xs"
          styles={{
            root: { padding: "8px 12px" },
            body: { display: "flex" },
            message: { flex: 1 },
          }}
        >
          <Group justify="space-between" style={{ flex: 1 }}>
            <Group gap="xs">
              <IconAlertTriangle
                size={16}
                color={isHardBlocked ? "red" : "orange"}
              />
              <Text size="sm" fw={500} c={isHardBlocked ? "red" : "yellow.8"}>
                {isHardBlocked
                  ? "Attendee limit reached — ticket creation is blocked"
                  : "Attendee limit reached"}
              </Text>
            </Group>
            <Text size="sm">
              {ticketsCount} / {attendeeLimit} attendees
              {isHardBlocked &&
                ` (+${ticketsCount - attendeeLimit} over limit)`}
            </Text>
            <Anchor href="mailto:support@congrs.com" size="sm" fw={500}>
              Contact us to upgrade
            </Anchor>
          </Group>
        </Alert>
      )}
      <Paper withBorder p="sm">
        <Group justify="space-between" mb={6}>
          <Text size="sm" c="dimmed">
            Attendees
          </Text>
          <Text size="sm" fw={500}>
            {ticketsCount} / {attendeeLimit} (
            {Math.round((ticketsCount / attendeeLimit) * 100)}%)
          </Text>
        </Group>
        <Progress
          value={progressValue}
          color={
            isHardBlocked ? "red" : isAttendeeLimitReached ? "yellow" : "blue"
          }
          size="sm"
        />
      </Paper>
    </Box>
  );
}
